export const ABOUT_LINK = window.CEMETERY_URL || '/';
